export const catalog_matrix = [
  {form_key:'hospital_id', catalog_key:'hospitals'},
  {form_key:'product_id', catalog_key:'products'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]